import React, { useState } from 'react';
import AppCard from '@crema/core/AppCard';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import { useAuthUser } from '@crema/utility/AuthHooks';
import { stringAvatar } from 'shared/constants/AppEnums';
import { Editor } from "@tinymce/tinymce-react";
import { onPostAnnoucement } from 'redux/actions/Portal';
import { useDispatch } from 'react-redux';
import AppInfoView from '@crema/core/AppInfoView';
import PropTypes from 'prop-types';
import { ButtonContained } from 'shared/components/Button';
import { Stack } from '@mui/material';
const CreatePost = ({ handleClose }) => {
  const dispatch = useDispatch();
  const { user } = useAuthUser();
  const [postData, setPostData] = useState({});
  const handleEditorChange = (content) => {
    setPostData({ title: 'Annoucement:', content: content });
  };

  const handlePost = () => {
    if (postData.content) {
      dispatch(onPostAnnoucement(postData, handleClose));
    }
  };

  const hTitle = (user) => {
    const url = 'https://apigw.kubekkp.coofis.com/bridge'
    return (
      <Box alignItems={'center'} display={'flex'}>
        <Avatar
          {...stringAvatar(user.displayName)}
          src={url + user.avatar}
          alt={user.displayName}
        />
        <Box marginLeft={2}>
          {user.displayName}
        </Box>
      </Box>
    );
  };

  return (
    <>
      {user &&
        <AppCard
          headerStyle={{ paddingTop: 5 }}
          title={hTitle(user)}
        // sxStyle={{maxHeight:'40vh'}}
        >
          <div id='letak-editor' style={{ zIndex: '10000' }}></div>
          <Editor
            id='isi'
            tinymceScriptSrc='/tinymce/tinymce.min.js'
            onEditorChange={(newValue) => {
              handleEditorChange(newValue);
            }}
            // onInit={(editor) => { editorRef.current = editor }}
            // initialValue={deskripsi}
            init={{
              fixed_toolbar_container: '#letak-editor',
              content_style:
                "body{font-size:14px; font-family: Nunito Sans,sans-serif;} body ol{list-style-type: decimal;padding-left:0.4cm;} body ol ol{list-style-type: lower-alpha;} body ol ol ol{list-style-type: lower-roman;}",
              inline: false,
              placeholder: 'Masukan Pengumuman....',
              plugins: [
                'powerpaste',
                'advlist',
                'autolink',
                'lists',
                'link',
                'image',
                'charmap',
                'searchreplace',
                'visualblocks',
                'advcode',
                'export',
                'quickbars',
                'insertdatetime',
                'table',
                'help',
                'wordcount',
                'emoticons',
                'noneditable',
                'autoresize'
              ]
              ,
              toolbar:
                'undo redo | pastetext | link image code| formatselect | bold italic backcolor | \
              alignleft aligncenter alignright alignjustify | \
              bullist numlist outdent indent| emoticons | removeformat',
              quickbars_selection_toolbar: 'bold italic | quicklink h2 h3 blockquote quickimage quicktable',
              min_height: 320,
              max_height: 320,
              toolbar_mode: 'sliding',
              skin: 'small',
              icons: 'small',
              allow_unsafe_link_target: true,
            }}
          />
          <Stack mt={4}>
            <ButtonContained onClick={() => handlePost()} variant="contained">Post</ButtonContained>
          </Stack>
          <AppInfoView></AppInfoView>
        </AppCard>
      }

    </>
  );
};

export default CreatePost;

CreatePost.propTypes = {
  handleClose: PropTypes.func
};